module.exports = __webpack_public_path__ + "static/media/sao_manuel.c15c3114.png";